import React from 'react'; 
import { useState } from 'react';
import { useEffect } from 'react';
import theme from '../../../muiTheme';
import './styles.scss';

const LavaLoader = ({propPrimaryColor, propSecondaryColor, diameter, isLoading}) => {

    const [primaryColor, setPrimaryColor] = useState('#f700a8'); 
    const [secondaryColor, setSecondaryColor] = useState('#ff8000');

    useEffect(()=>{

        if(propPrimaryColor){
            setPrimaryColor(propPrimaryColor);
        }

        if(propSecondaryColor){
            setSecondaryColor(propSecondaryColor);
        }


    },[propPrimaryColor, propSecondaryColor]);

    let circleCX = diameter ? diameter/2 : '100'; 
    let circleCY = diameter ? diameter/2 : '100'; 
    let circleRadius = diameter ? diameter*0.32 : '64'; 

    let pathValues = {

    }; 

    return (
        <div className={`lava-loader ${isLoading ? 'show' : 'hide'} `} style={{'--primary-color': primaryColor, '--secondary-color': secondaryColor}}>
            <svg className="well-played">
                <defs>
                    <filter id="well-played-indeed">
                        <feGaussianBlur in="SourceGraphic" stdDeviation="7" result="blur" />
                        <feColorMatrix
                            in="blur"
                            mode="matrix"
                            values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 20 -10"
                            result="interior"
                        />
                        <feComposite in="SourceGraphic" in2="interior" operator="atop" />
                    </filter>
                </defs>
            </svg>

            <svg className="spin" width={diameter || '200'} height={diameter || '200'} viewBox={`0 0 ${diameter || '200' } ${diameter || '200'}`}>
                <defs>
                    <linearGradient id="linGrad">
                        <stop className="break_one" offset="0" />
                        <stop className="break_two" offset="1" />
                    </linearGradient>
                    <linearGradient
                        y2="160"
                        x2="160"
                        y1="40"
                        x1="40"
                        gradientUnits="userSpaceOnUse"
                        id="gradient"
                        xlinkHref="#linGrad"
                    />
                </defs>
                <path
                    className="half"
                    d="m 164,100 c 0,-35.346224 -28.65378,-64 -64,-64 -35.346224,0 -64,28.653776 -64,64 0,35.34622 28.653776,64 64,64 35.34622,0 64,-26.21502 64,-64 0,-37.784981 -26.92058,-64 -64,-64 -37.079421,0 -65.267479,26.922736 -64,64 1.267479,37.07726 26.703171,65.05317 64,64 37.29683,-1.05317 64,-64 64,-64"
                />
                <circle className="stretch" cx={circleCX} cy={circleCY} r={circleRadius} />
            </svg>

            {/* <svg className="shadow" width={diameter || '200'} height={diameter || '200'} viewBox={`0 0 ${diameter || '200' } ${diameter || '200'}`}>
                <path
                    className="half"
                    d="m 164,100 c 0,-35.346224 -28.65378,-64 -64,-64 -35.346224,0 -64,28.653776 -64,64 0,35.34622 28.653776,64 64,64 35.34622,0 64,-26.21502 64,-64 0,-37.784981 -26.92058,-64 -64,-64 -37.079421,0 -65.267479,26.922736 -64,64 1.267479,37.07726 26.703171,65.05317 64,64 37.29683,-1.05317 64,-64 64,-64"
                />
                <circle className="stretch" cx={circleCX} cy={circleCY} r={circleRadius} />
            </svg> */}

        </div>
    );
}

export default LavaLoader; 